<template>
  <div class="app-container">
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/system/hardware_manufacturer_park_rel_add')"
      >添加</el-button
    >
    <el-button
      type="primary"
      plain
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      type="primary"
      @click="(screen.page = 1),  fetchData()"
      style="margin-bottom: 5px; float: right"
      >搜索</el-button
    >
    <el-select
      filterable
      style="float: right"
      v-model="screen.hardware_manufacturer_id"
      placeholder="请选择厂商"
    >
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in MList"
        :key="index"
      ></el-option>
    </el-select>
    <el-select
      filterable
      style="float: right; margin-right: 10px"
      v-model="screen.hardware_id"
      placeholder="请选择硬件"
    >
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in hardwareList"
        :key="index"
      ></el-option>
    </el-select>
    <el-select
      filterable
      style="float: right; margin-right: 10px"
      v-model="screen.park_id"
      placeholder="请选择园区"
      :disabled="userInfo.park_id != 0"
      @change="parkChange"
    >
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="厂商" min-width="150">
        <template slot-scope="scope">
          <span>{{
            scope.row.hardware_manufacturer
              ? scope.row.hardware_manufacturer.name
              : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="设备" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.hardware ? scope.row.hardware.name : "" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="时间类型">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? '月' : scope.row.type == 2 ? '季' : scope.row.type == 3 ? '半年' : scope.row.type == 4 ? '年' : '' }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="创建时间" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="楼号">
        <template slot-scope="scope">
          <span>{{ scope.row.building }}</span>
        </template>
      </el-table-column>
      <el-table-column label="单价">
        <template slot-scope="scope">
          {{ scope.row.price }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column> -->
      <el-table-column prop="created_at" label="操作" width="250" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            v-if="roles.includes('/system/hardware_manufacturer_park_rel_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleInfo(scope.row)"
            v-if="roles.includes('/system/hardware_manufacturer_park_rel_edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/system/hardware_manufacturer_park_rel_del')"
            >删除</el-button
          >
          <!-- <el-button
            size="mini"
            type="success"
            @click="getRegisterUser(scope.row.id)"
            v-if="roles.includes('/hire/intention_user')"
            >意向用户列表</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
            @change="formParkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择硬件" prop="hardware_id">
          <el-select
            filterable
            v-model="ruleForm.hardware_id"
            :disabled="cztype == 'see'"
            placeholder="请选择硬件"
            @change="formHardwareChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in onHardwareList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择厂商" prop="hardware_manufacturer_id">
          <el-select
            filterable
            v-model="ruleForm.hardware_manufacturer_id"
            :disabled="cztype == 'see'"
            placeholder="请选择厂商"
          >
            <el-option
              :label="item.hardware_manufacturer.name"
              :value="item.hardware_manufacturer.id"
              v-for="(item, index) in onMList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="" prop="hardware_id">
          <span style="color: red">非开发人员，请勿随意配置</span>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <!-- <el-button
            v-if="cztype == 'see'"
            type="primary"
            @click="cztype = 'edit'"
          >
            编辑
          </el-button> -->
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit' || cztype == 'see'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { housing_type } from "@/api/common";
import { openPark, delImage } from "@/api/index";
import {
  HMP_rel_add,
  HMP_rel_edit,
  HMP_rel_list,
  HMP_rel_del,
  HMP_rel_info,
  manufacturer_list,
  hardware_list,
  get_usable_hardware_lists,
  getIdHardware,
} from "@/api/conf";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      MList: [],
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        is_page: 1,
        page: 1,
        page_size: 15,
        park_id: "",
        hardware_manufacturer_id: "",
        hardware_id: "",
      },
      hardwareList: [],
      total: 0,
      ruleForm: {},
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        type: [
          { required: true, message: "请选择时间类型", trigger: "change" },
        ],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        price: [{ required: true, message: "请输入租车费用", trigger: "blur" }],
      },
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      onHardwareList: [],
      onMList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getMList();
    this.getHardware();
    this.getPark();
  },
  methods: {
    formHardwareChange(e) {
      this.ruleForm.hardware_manufacturer_id = "";
      this.getOnML(e);
    },
    getOnHardware(id) {
      get_usable_hardware_lists({ park_id: id }).then((res) => {
        this.onHardwareList = res.data.lists;
      });
    },
    getOnML(id) {
      getIdHardware({ hardware_id: id }).then((res) => {
        this.onMList = res.data.lists;
      });
    },
    parkChange(e) {},
    formParkChange(e) {
      this.getOnHardware(e);
    },
    reset() {
      this.screen = {
        park_id: "",
        hardware_manufacturer_id: "",
        hardware_id: "",
        page: 1,
        page_size: 15,
        is_page: 1,
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              HMP_rel_edit(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleInfo(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.getOnHardware(val.park_id);
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.getOnHardware(val.park_id);
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      HMP_rel_info({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.getOnML(res.data.info.hardware_id);
        that.ruleForm = {
          id: res.data.info.id,
          park_id: res.data.info.park_id,
          hardware_id: res.data.info.hardware_id,
          hardware_manufacturer_id: res.data.info.hardware_manufacturer_id,
        };

        that.onHardwareList.push(res.data.info.hardware);
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          HMP_rel_del({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              HMP_rel_add(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_id: "",
        hardware_manufacturer_id: "",
        hardware_id: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取硬件厂商
    getMList() {
      this.MList = [];
      manufacturer_list().then((res) => {
        this.MList = res.data.lists.data;
      });
    },

    // 获取硬件
    getHardware() {
      this.hardwareList = [];
      hardware_list().then((res) => {
        this.hardwareList = res.data.lists.data;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      HMP_rel_list(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
